// @ts-expect-error legacy
import LoadBreakdownGraph from "@/pages/rum/v2/details/graphs/LoadBreakdownGraph.jsx";
import {RUMGraphHeader} from "@/pages/rum/v2/details/graphs/RumGraphHeader.tsx";
import {ReportSpec} from "@/pages/rum/v2/details/ReportDefType.ts";

interface SectionBreakdownProps {
  reportSpec: ReportSpec;
  checkName: string;
  breakdown: JSON;
}

export const SectionBreakdown = ({reportSpec, checkName, breakdown}: SectionBreakdownProps) => {
  if (!reportSpec.breakdown || !breakdown) {
    return null;
  }
  return (
    <>
      <hr className="my-4" />
      <div className="row">
        <RUMGraphHeader title={`${reportSpec.name} breakdown`} supportLink={reportSpec.doc} />
        <LoadBreakdownGraph
          checkName={checkName}
          data={breakdown}
          sections={reportSpec.breakdown?.sections}
          markers={reportSpec.breakdown?.markers}
          noDataMessage={reportSpec.noDataMessage}
        />
      </div>
    </>
  );
};
